<style scoped>
.floating-cart-wrapper {
    position: fixed;
    top: 50vh;
    right: 0;
    transform: translateY(-50%);
    z-index: 20;

    @apply flex flex-col items-center;
    @apply border-2 border-primary bg-white shadow;
}

/* calc(75rem + (75rem * 1 / 4) * 2) */
@media all and (min-width: 112.5rem) {
    .floating-cart-wrapper {
        right: calc((100vw - 75rem) / 2 - (70rem * 1 / 4));
    }
}

.slide-enter-active {
    animation: slide 0.5s;
}
.slide-leave-active {
    animation: slide 0.5s reverse;
}
@keyframes slide {
    0% {
        transform: translate(100%, -50%);
    }
    100% {
        transform: translate(0%, -50%);
    }
}
</style>

<template>
    <transition name="slide">
        <div
            v-if="expand"
            @mouseover="mouseover"
            @mouseleave="mouseleave"
            class="floating-cart-wrapper w-3/5 sm:w-64 p-2"
        >
            <bubble arrowStyle="point-down" imagePosition="right" class="my-2">
                <template #image>
                    <img :src="img1s112" class="w-10 sm:w-16" />
                </template>
                <div class="-mx-1 sm:-mx-2 text-sm sm:text-base">
                    放咗入購物車啦！
                </div>
            </bubble>

            <div class=" self-stretch">
                <productImage imageType="small" :product="lastAddedCartItem" />
            </div>
            <router-link to="/cart" target="button" class="btn btn-primary">
                {{ $t('cart.check.cart') }}
            </router-link>
        </div>
    </transition>
</template>

<script>
import productImage from './productImage.vue';
import img1s112 from '@/assets/img/1-112.png';
import bubble from './bubble.vue';

export default {
    components: {
        productImage,
        bubble
    },
    data() {
        return {
            expand: false,
            collapseTimeout: undefined,
            img1s112
        };
    },
    computed: {
        lastAddedCartItem() {
            return this.$store.state.lastAddedCartItem;
        }
    },
    beforeDestroy() {
        this.clearCollapseTimeout();
    },
    mounted() {
        this.$watch('lastAddedCartItem', newVal => {
            if (newVal) {
                this.expandForMilliSecond();
            }
        });
    },
    methods: {
        expandForMilliSecond(timeout = 3 * 1000) {
            this.clearCollapseTimeout();
            this.expand = true;
            this.collapseTimeout = setTimeout(() => {
                this.expand = false;
            }, timeout);
        },
        clearCollapseTimeout() {
            if (this.collapseTimeout) clearTimeout(this.collapseTimeout);
        },
        mouseover() {
            this.clearCollapseTimeout();
            this.expand = true;
        },
        mouseleave() {
            this.expandForMilliSecond(0.7 * 1000);
        }
    }
};
</script>
